import * as THREE from 'three'

/**
 * Calculates nearest power of two rounding down.
 */
export const nearestPowerOfTwo = (number: number) => {
  return Math.pow(2, Math.floor(Math.log(number) / Math.log(2)))
}

/**
 * Gets 3D center vector from 3D object.
 */
export const getObjectCenterVector = (object: THREE.Object3D) => {
  const box = new THREE.Box3()
  box.expandByObject(object)

  const center = box.getCenter(new THREE.Vector3())

  return center
}

/**
 * Gets 3D size vector from 3D object.
 */
export const getObjectSizeVector = (object: THREE.Object3D) => {
  const box = new THREE.Box3()
  box.expandByObject(object)

  const size = box.getSize(new THREE.Vector3())

  return size
}
